(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("csstips"), require("csx"), require("typestyle"), require("vue"), require("vue-property-decorator"), require("vue-tsx-support"), require("vuex-class"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , ], factory);
	else if(typeof exports === 'object')
		exports["popover"] = factory(require("@splat/constant"), require("csstips"), require("csx"), require("typestyle"), require("vue"), require("vue-property-decorator"), require("vue-tsx-support"), require("vuex-class"));
	else
		root["popover"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE_vuex_class__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/absolutePopover.tsx":
/*!*********************************!*\
  !*** ./src/absolutePopover.tsx ***!
  \*********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_9__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_9__.Mutations; },
/* harmony export */   "PopoverGetter": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_9__.PopoverGetter; },
/* harmony export */   "PopoverMutation": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_9__.PopoverMutation; },
/* harmony export */   "factory": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_9__.factory; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _type__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./type */ "./src/type.ts");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var element_ui_lib_utils_clickoutside__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! element-ui/lib/utils/clickoutside */ "../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/clickoutside.js");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_17__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};













function isChildOf(child, parent) {
  var cur = child.parentElement;

  while (cur && cur !== parent) {
    cur = cur.parentElement;
  }

  return !!cur;
}

var AbsolutePopover = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(AbsolutePopover, _tsx$Component);

  var _super = _createSuper(AbsolutePopover);

  function AbsolutePopover() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, AbsolutePopover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "lastZIndex", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "updateLastZIndex", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "block", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "closeOnPopover", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "autoHidePop", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "trigger", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "direction", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "dropMaxHeight", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabledPropagation", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "popoverClassName", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "popoverClassNameDeep", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "leaveSetTimeoutId", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "minWidth", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "innerVerticalPlace", 'up');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "popoverElm", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "zIndex", 20);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(AbsolutePopover, [{
    key: "setPosition",
    value: function setPosition() {
      var _this$$refs$activity;

      var activityRect = (_this$$refs$activity = this.$refs.activity) === null || _this$$refs$activity === void 0 ? void 0 : _this$$refs$activity.getBoundingClientRect();
      var popWidth = this.$refs.popover.clientWidth;
      var popHeight = this.$refs.popover.clientHeight;
      var direction = this.direction;
      this.minWidth = activityRect.width;
      var toRight = "".concat(activityRect.left + window.scrollX, "px");
      var toLeft = "".concat(activityRect.right + window.scrollX - popWidth, "px");
      var _limitSpace = 12;

      if (direction & _type__WEBPACK_IMPORTED_MODULE_11__.Direction.right) {
        if (popWidth + _limitSpace > activityRect.right) {
          ;
          this.$refs.popover.style.left = toLeft;
        } else {
          ;
          this.$refs.popover.style.left = toRight;
        }
      } else {
        if (activityRect.left + popWidth + _limitSpace > window.innerWidth) {
          ;
          this.$refs.popover.style.left = toLeft;
        } else {
          ;
          this.$refs.popover.style.left = toRight;
        }
      }

      var top = 0;

      if (direction & _type__WEBPACK_IMPORTED_MODULE_11__.Direction.down) {
        if (activityRect.bottom + popHeight + _limitSpace > window.innerHeight) {
          top = activityRect.top - 10;
          this.innerVerticalPlace = 'up';
        } else {
          this.innerVerticalPlace = 'down';
          top = activityRect.bottom;
        }
      } else {
        if (activityRect.top < popHeight + _limitSpace) {
          top = activityRect.bottom;
          this.innerVerticalPlace = 'down';
        } else {
          top = activityRect.top - 10;
          this.innerVerticalPlace = 'up';
        }
      }

      ;
      this.$refs.popover.style.top = "".concat(top + (document.scrollingElement ? document.scrollingElement.scrollTop : 0), "px");

      if (this.autoHidePop && (this.$refs.popover.getBoundingClientRect().bottom < 0 || this.$refs.popover.getBoundingClientRect().top > document.body.clientHeight)) {
        this.onInput(false, true);
        this.handleValueChange(false);
      }
    }
  }, {
    key: "onInput",
    value: function onInput(v, o) {}
  }, {
    key: "removeListener",
    value: function removeListener() {
      var setPosition = this.setPosition;
      window.removeEventListener('scroll', setPosition, true);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', setPosition);
      }
    }
  }, {
    key: "handleValueChange",
    value: function handleValueChange(newV) {
      var setPosition = this.setPosition;

      if (newV) {
        window.addEventListener('scroll', setPosition, true);

        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', setPosition);
        }

        this.zIndex = this.lastZIndex;
        this.updateLastZIndex(this.lastZIndex + 1);
        setPosition();
      } else {
        this.updateLastZIndex(this.lastZIndex - 1 > 20 ? this.lastZIndex - 1 : 20);
        this.removeListener();
        this.$refs.popover.style.left = '0px';
        this.$refs.popover.style.top = '0px';
      }
    }
  }, {
    key: "handleResolveInput",
    value: function handleResolveInput(v, outSide) {
      if (this.trigger === _type__WEBPACK_IMPORTED_MODULE_11__.Trigger.manual || this.disabled) return;

      if (v === this.value) {
        return;
      }

      this.onInput(v, outSide);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this2 = this;

      if (!this.disabled && !this.value) {
        this.handleResolveInput(true, false);
      } else if (isChildOf(e.target, this.$refs.popover)) {
        if (this.closeOnPopover) {
          this.handleResolveInput(false, false);
        } else {
          this.$nextTick(function () {
            return _this2.setPosition();
          });
        }
      } else {
        this.handleResolveInput(false, false);
      }

      if (this.disabledPropagation) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      if (this.trigger === _type__WEBPACK_IMPORTED_MODULE_11__.Trigger.click) {
        this.handleResolveInput(false, true);
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      if (this.trigger === _type__WEBPACK_IMPORTED_MODULE_11__.Trigger.hover) {
        if (this.leaveSetTimeoutId) {
          clearTimeout(this.leaveSetTimeoutId);
          this.leaveSetTimeoutId = 0;
        }

        this.handleResolveInput(true, false);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var _this3 = this;

      if (this.trigger === _type__WEBPACK_IMPORTED_MODULE_11__.Trigger.hover) {
        this.leaveSetTimeoutId = setTimeout(function () {
          _this3.handleResolveInput(false, true);
        }, 50);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var block = this.block,
          handleClick = this.handleClick,
          handleClickOutside = this.handleClickOutside,
          handleMouseEnter = this.handleMouseEnter,
          handleMouseLeave = this.handleMouseLeave;
      return h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.dropDownClassName, block && _style__WEBPACK_IMPORTED_MODULE_10__.dropDownBlockClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('popover-activity'), this.value && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('popover-activity', 'actived')),
        "on": {
          "click": handleClick,
          "mouseenter": handleMouseEnter,
          "mouseleave": handleMouseLeave
        },
        "ref": 'activity'
      }, [this.$slots.activity, h("div", {
        "ref": 'popoverContainer',
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.wrapPopClassName(this.zIndex), this.value ? 'popover--abs' : undefined)
      }, [h("div", {
        "ref": 'popover',
        "on": {
          "mouseenter": handleMouseEnter,
          "mouseleave": handleMouseLeave,
          "click": handleClick
        },
        "directives": [{
          name: "clickoutside",
          value: handleClickOutside
        }],
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(this.value ? _style__WEBPACK_IMPORTED_MODULE_10__.subMenuActive(this.dropMaxHeight) : _style__WEBPACK_IMPORTED_MODULE_10__.subMenuLeave, _style__WEBPACK_IMPORTED_MODULE_10__.dropdownPopoverClassName, this.innerVerticalPlace === 'down' ? undefined : _style__WEBPACK_IMPORTED_MODULE_10__.rotatexTohackAnimateFromBottom(true), (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.style)({
          maxHeight: (0,csx__WEBPACK_IMPORTED_MODULE_12__.px)(this.dropMaxHeight),
          minWidth: this.minWidth,
          visibility: this.value ? 'inherit' : 'hidden'
        }), this.popoverClassNameDeep, this.popoverClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('popover', 'abs'))
      }, [h("div", {
        "class": this.innerVerticalPlace === 'down' ? undefined : _style__WEBPACK_IMPORTED_MODULE_10__.rotatexTohackAnimateFromBottom(false)
      }, [this.$slots.default])])])]);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.popoverElm = this.$refs.popoverContainer;
      document.body.appendChild(this.popoverElm);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      this.removeListener();
      if (this.leaveSetTimeoutId) clearTimeout(this.leaveSetTimeoutId);

      if (this.popoverElm) {
        document.body.removeChild(this.popoverElm);
        this.popoverElm = null;
      }
    }
  }]);

  return AbsolutePopover;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_16__.Component);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_9__.PopoverGetter)(_store__WEBPACK_IMPORTED_MODULE_9__.Getters.LastZIndex)], AbsolutePopover.prototype, "lastZIndex", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_9__.PopoverMutation)(_store__WEBPACK_IMPORTED_MODULE_9__.Mutations.LastZIndex)], AbsolutePopover.prototype, "updateLastZIndex", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)()], AbsolutePopover.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)()], AbsolutePopover.prototype, "block", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)()], AbsolutePopover.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)({
  default: true
})], AbsolutePopover.prototype, "closeOnPopover", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)({
  default: true
})], AbsolutePopover.prototype, "autoHidePop", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)({
  default: _type__WEBPACK_IMPORTED_MODULE_11__.Trigger.click
})], AbsolutePopover.prototype, "trigger", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)({
  default: _type__WEBPACK_IMPORTED_MODULE_11__.Direction.leftDown
})], AbsolutePopover.prototype, "direction", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)({
  default: 500
})], AbsolutePopover.prototype, "dropMaxHeight", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)()], AbsolutePopover.prototype, "disabledPropagation", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Prop)()], AbsolutePopover.prototype, "popoverClassName", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Inject)({
  from: 'popoverClassNameDeep',
  default: ''
})], AbsolutePopover.prototype, "popoverClassNameDeep", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Emit)('input')], AbsolutePopover.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Watch)('value')], AbsolutePopover.prototype, "handleValueChange", null);

AbsolutePopover = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_15__.Component)({
  directives: {
    Clickoutside: element_ui_lib_utils_clickoutside__WEBPACK_IMPORTED_MODULE_13__["default"]
  }
})], AbsolutePopover);
/* harmony default export */ __webpack_exports__["default"] = (AbsolutePopover);

/***/ }),

/***/ "./src/relativePopover.tsx":
/*!*********************************!*\
  !*** ./src/relativePopover.tsx ***!
  \*********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _type__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./type */ "./src/type.ts");
/* harmony import */ var element_ui_lib_utils_clickoutside__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! element-ui/lib/utils/clickoutside */ "../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/clickoutside.js");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};










function isChildOf(child, parent) {
  var cur = child.parentElement;

  while (cur && cur !== parent) {
    cur = cur.parentElement;
  }

  return !!cur;
}

var Popover = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Popover, _tsx$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "block", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "closeOnPopover", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "trigger", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "direction", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "dropMaxHeight", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabledPropagation", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "leaveSetTimeoutId", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Popover, [{
    key: "directionClassName",
    get: function get() {
      var direction = this.direction;
      var result = [];

      if (direction & _type__WEBPACK_IMPORTED_MODULE_10__.Direction.right) {
        result.push(_style__WEBPACK_IMPORTED_MODULE_9__.dropDownDirectionRightClassName);
      } else {
        result.push(_style__WEBPACK_IMPORTED_MODULE_9__.dropDownDirectionLeftClassName);
      }

      if (direction & _type__WEBPACK_IMPORTED_MODULE_10__.Direction.down) {
        result.push(_style__WEBPACK_IMPORTED_MODULE_9__.dropdownDirectionBottomClassName);
      } else {
        result.push(_style__WEBPACK_IMPORTED_MODULE_9__.dropdownDirectionUpClassName);
      }

      return typestyle__WEBPACK_IMPORTED_MODULE_12__.classes.apply(void 0, result);
    }
  }, {
    key: "onInput",
    value: function onInput(v, o) {}
  }, {
    key: "handleResolveInput",
    value: function handleResolveInput(v, o) {
      if (v === this.value || this.disabled) {
        return;
      }

      this.onInput(v, o);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (!this.disabled && (!this.value || !this.$refs.popover)) {
        this.handleResolveInput(true, false);
      } else if (isChildOf(e.target, this.$refs.popover)) {
        if (this.closeOnPopover) {
          this.handleResolveInput(false, false);
        }
      } else {
        this.handleResolveInput(false, false);
      }

      if (this.disabledPropagation) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      if (this.trigger === _type__WEBPACK_IMPORTED_MODULE_10__.Trigger.click) {
        this.handleResolveInput(false, true);
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      if (this.leaveSetTimeoutId) clearTimeout(this.leaveSetTimeoutId);

      if (this.trigger === _type__WEBPACK_IMPORTED_MODULE_10__.Trigger.hover) {
        this.handleResolveInput(true, false);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var _this2 = this;

      this.leaveSetTimeoutId = setTimeout(function () {
        if (_this2.trigger === _type__WEBPACK_IMPORTED_MODULE_10__.Trigger.hover) {
          _this2.handleResolveInput(false, true);
        }
      }, 50);
    }
  }, {
    key: "handleBeforeEnter",
    value: function handleBeforeEnter(e) {
      var el = e;
      el.style.cssText += 'display:none';
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(e, done) {
      var _this3 = this;

      if (this.disabled) return;
      var el = e;
      setTimeout(function () {
        el.style.cssText += "max-height:".concat(_this3.dropMaxHeight, "px;display:block");
      }, 0);
      el.addEventListener('transitioned', done, {
        once: true
      });
    }
  }, {
    key: "handleBeforeLeave",
    value: function handleBeforeLeave(e) {
      var el = e;
      el.style.cssText += "max-height:".concat(this.dropMaxHeight, "px;display:block");
    }
  }, {
    key: "handleLeave",
    value: function handleLeave(e, done) {
      var el = e;
      setTimeout(function () {
        el.style.cssText += 'display:none';
      }, 0);
      el.addEventListener('transitioned', done, {
        once: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value,
          block = this.block,
          directionClassName = this.directionClassName,
          handleClick = this.handleClick,
          handleClickOutside = this.handleClickOutside,
          handleMouseEnter = this.handleMouseEnter,
          handleMouseLeave = this.handleMouseLeave;
      return h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_9__.dropDownClassName, block && _style__WEBPACK_IMPORTED_MODULE_9__.dropDownBlockClassName),
        "on": {
          "click": handleClick,
          "mouseenter": handleMouseEnter,
          "mouseleave": handleMouseLeave
        },
        "directives": [{
          name: "clickoutside",
          value: handleClickOutside
        }]
      }, [this.$slots.activity, h("transition", {
        "on": {
          "beforeEnter": this.handleBeforeEnter,
          "enter": this.handleEnter,
          "beforeLeave": this.handleBeforeLeave,
          "leave": this.handleLeave
        },
        "attrs": {
          "enterActiveClass": _style__WEBPACK_IMPORTED_MODULE_9__.relativeSubMenuActive,
          "leaveActiveClass": _style__WEBPACK_IMPORTED_MODULE_9__.relativeSubMenuLeave
        }
      }, [value ? h("div", {
        "ref": 'popover',
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_9__.relativeDropdownPopoverClassName, directionClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('popover'))
      }, [this.$slots.default]) : null])]);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.leaveSetTimeoutId) clearTimeout(this.leaveSetTimeoutId);
    }
  }]);

  return Popover;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Popover.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Popover.prototype, "block", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Popover.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: true
})], Popover.prototype, "closeOnPopover", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: _type__WEBPACK_IMPORTED_MODULE_10__.Trigger.click
})], Popover.prototype, "trigger", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: _type__WEBPACK_IMPORTED_MODULE_10__.Direction.leftDown
})], Popover.prototype, "direction", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: 500
})], Popover.prototype, "dropMaxHeight", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], Popover.prototype, "disabledPropagation", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('input')], Popover.prototype, "onInput", null);

Popover = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component)({
  directives: {
    Clickoutside: element_ui_lib_utils_clickoutside__WEBPACK_IMPORTED_MODULE_11__["default"]
  }
})], Popover);
/* harmony default export */ __webpack_exports__["default"] = (Popover);

/***/ }),

/***/ "./src/store/getters.ts":
/*!******************************!*\
  !*** ./src/store/getters.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* binding */ Getters; },
/* harmony export */   "genGetters": function() { return /* binding */ genGetters; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");

var Getters;

(function (Getters) {
  Getters["LastZIndex"] = "GetLastZIndex";
})(Getters || (Getters = {}));

function genGetters() {
  var getters = (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, Getters.LastZIndex, function (state) {
    return state.LastZIndex;
  });

  return getters;
}

/***/ }),

/***/ "./src/store/index.ts":
/*!****************************!*\
  !*** ./src/store/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PopoverGetter": function() { return /* binding */ PopoverGetter; },
/* harmony export */   "PopoverMutation": function() { return /* binding */ PopoverMutation; },
/* harmony export */   "factory": function() { return /* binding */ factory; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _mutations__WEBPACK_IMPORTED_MODULE_0__.Mutations; },
/* harmony export */   "Getters": function() { return /* reexport safe */ _getters__WEBPACK_IMPORTED_MODULE_1__.Getters; }
/* harmony export */ });
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mutations */ "./src/store/mutations.ts");
/* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getters */ "./src/store/getters.ts");
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vuex-class */ "vuex-class");
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vuex_class__WEBPACK_IMPORTED_MODULE_2__);



var moduleName = 'popover';
var ns = (0,vuex_class__WEBPACK_IMPORTED_MODULE_2__.namespace)(moduleName);
var PopoverGetter = ns.Getter;
var PopoverMutation = ns.Mutation;
var initialStore = {
  LastZIndex: 20
};
function factory(store) {
  store.registerModule(moduleName, {
    namespaced: true,
    state: initialStore,
    getters: (0,_getters__WEBPACK_IMPORTED_MODULE_1__.genGetters)(),
    mutations: (0,_mutations__WEBPACK_IMPORTED_MODULE_0__.genMutations)()
  });
}


/***/ }),

/***/ "./src/store/mutations.ts":
/*!********************************!*\
  !*** ./src/store/mutations.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mutations": function() { return /* binding */ Mutations; },
/* harmony export */   "genMutations": function() { return /* binding */ genMutations; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");

var Mutations;

(function (Mutations) {
  Mutations["LastZIndex"] = "UpdateLastZIndex";
})(Mutations || (Mutations = {}));

function genMutations() {
  var mutations = (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, Mutations.LastZIndex, function (state, value) {
    state.LastZIndex = value;
  });

  return mutations;
}

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dropDownClassName": function() { return /* binding */ dropDownClassName; },
/* harmony export */   "dropDownBlockClassName": function() { return /* binding */ dropDownBlockClassName; },
/* harmony export */   "dropdownPopoverClassName": function() { return /* binding */ dropdownPopoverClassName; },
/* harmony export */   "rotatexTohackAnimateFromBottom": function() { return /* binding */ rotatexTohackAnimateFromBottom; },
/* harmony export */   "dropdownDirectionBottomClassName": function() { return /* binding */ dropdownDirectionBottomClassName; },
/* harmony export */   "dropdownDirectionUpClassName": function() { return /* binding */ dropdownDirectionUpClassName; },
/* harmony export */   "dropDownDirectionLeftClassName": function() { return /* binding */ dropDownDirectionLeftClassName; },
/* harmony export */   "dropDownDirectionRightClassName": function() { return /* binding */ dropDownDirectionRightClassName; },
/* harmony export */   "subMenuActive": function() { return /* binding */ subMenuActive; },
/* harmony export */   "subMenuLeave": function() { return /* binding */ subMenuLeave; },
/* harmony export */   "wrapPopClassName": function() { return /* binding */ wrapPopClassName; },
/* harmony export */   "relativeDropdownPopoverClassName": function() { return /* binding */ relativeDropdownPopoverClassName; },
/* harmony export */   "relativeSubMenuActive": function() { return /* binding */ relativeSubMenuActive; },
/* harmony export */   "relativeSubMenuLeave": function() { return /* binding */ relativeSubMenuLeave; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_3__);




var dropDownClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.layerParent, csstips__WEBPACK_IMPORTED_MODULE_1__.inlineBlock, {
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.PopoverSizes.fontSize)
});
var dropDownBlockClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_1__.width)((0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100)), {
  display: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)('block')
});
var dropdownPopoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.attachToLayerParent, (0,csstips__WEBPACK_IMPORTED_MODULE_1__.padding)(0), {
  marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(4),
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.PopoverColors.background.toString(),
  zIndex: 4,
  boxShadow: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.popoverBoxShadow,
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.PopoverSizes.raduisSize),
  willChange: 'left, top'
});
var rotatexTohackAnimateFromBottom = function rotatexTohackAnimateFromBottom() {
  var isParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    transform: 'rotatex(180deg)',
    transformOrigin: isParent ? 'top' : undefined
  });
};
var dropdownDirectionBottomClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  top: (0,csx__WEBPACK_IMPORTED_MODULE_2__.calc)("".concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100)))
});
var dropdownDirectionUpClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  bottom: (0,csx__WEBPACK_IMPORTED_MODULE_2__.calc)("".concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100), " + ").concat((0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(4)))
});
var dropDownDirectionLeftClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  left: 0
});
var dropDownDirectionRightClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  right: 0
});

var hackOverflowHidden = function hackOverflowHidden() {
  var maxHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.keyframes)({
    '0%': {
      overflow: 'hidden',
      maxHeight: 0
    },
    '99%': {
      overflow: 'hidden'
    },
    '100%': {
      overflow: 'visible',
      maxHeight: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(maxHeight)
    }
  });
};

var subMenuActive = function subMenuActive() {
  var maxHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    animationName: hackOverflowHidden(maxHeight),
    animationIterationCount: 1,
    animationDuration: '0.6s',
    animationFillMode: 'forwards'
  });
};
var subMenuLeave = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  transition: 'max-height .1s',
  overflow: 'hidden'
});
var wrapPopClassName = function wrapPopClassName() {
  var zIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: (0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100),
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(12),
    zIndex: zIndex
  });
};
var relativeDropdownPopoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)(csstips__WEBPACK_IMPORTED_MODULE_1__.attachToLayerParent, (0,csstips__WEBPACK_IMPORTED_MODULE_1__.padding)(0), {
  marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(4),
  maxHeight: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(0),
  overflow: (0,csx__WEBPACK_IMPORTED_MODULE_2__.important)('hidden'),
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.PopoverColors.background.toString(),
  zIndex: 4,
  minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_2__.percent)(100),
  boxShadow: _splat_constant__WEBPACK_IMPORTED_MODULE_0__.popoverBoxShadow,
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_2__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_0__.PopoverSizes.raduisSize)
});
var relativeSubMenuActive = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  transition: 'max-height .4s'
});
var relativeSubMenuLeave = (0,typestyle__WEBPACK_IMPORTED_MODULE_3__.style)({
  transition: 'max-height .1s'
});

/***/ }),

/***/ "./src/type.ts":
/*!*********************!*\
  !*** ./src/type.ts ***!
  \*********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Trigger": function() { return /* binding */ Trigger; },
/* harmony export */   "Direction": function() { return /* binding */ Direction; }
/* harmony export */ });
var Trigger;

(function (Trigger) {
  Trigger["click"] = "click";
  Trigger["hover"] = "hover";
  Trigger["manual"] = "manual";
})(Trigger || (Trigger = {}));

var Direction;

(function (Direction) {
  Direction[Direction["down"] = 1] = "down";
  Direction[Direction["right"] = 2] = "right";
  Direction[Direction["leftUp"] = 0] = "leftUp";
  Direction[Direction["leftDown"] = 1] = "leftDown";
  Direction[Direction["rightUp"] = 2] = "rightUp";
  Direction[Direction["rightDown"] = 3] = "rightDown";
})(Direction || (Direction = {}));

/***/ }),

/***/ "../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/clickoutside.js":
/*!***********************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/clickoutside.js ***!
  \***********************************************************************************************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(/*! vue */ "vue");

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(/*! element-ui/lib/utils/dom */ "../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nodeList = [];
var ctx = '@@clickoutsideContext';

var startClick = void 0;
var seed = 0;

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
  return startClick = e;
});

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
exports["default"] = {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};

/***/ }),

/***/ "../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/dom.js":
/*!**************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/element-ui-virtual-88381b79a8/0/cache/element-ui-npm-2.15.3-8468e3169f-6438fb97a7.zip/node_modules/element-ui/lib/utils/dom.js ***!
  \**************************************************************************************************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__(/*! vue */ "vue");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

var isScroll = exports.isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null && vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto)/);
};

var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = exports.isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue":
/*!*****************************************************!*\
  !*** external {"commonjs":"vue","commonjs2":"vue"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "vuex-class":
/*!*******************************************************************!*\
  !*** external {"commonjs":"vuex-class","commonjs2":"vuex-class"} ***!
  \*******************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vuex_class__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AbsolutePopover": function() { return /* reexport safe */ _absolutePopover__WEBPACK_IMPORTED_MODULE_2__["default"]; },
/* harmony export */   "factory": function() { return /* reexport safe */ _absolutePopover__WEBPACK_IMPORTED_MODULE_2__.factory; },
/* harmony export */   "Direction": function() { return /* reexport safe */ _type__WEBPACK_IMPORTED_MODULE_3__.Direction; },
/* harmony export */   "Trigger": function() { return /* reexport safe */ _type__WEBPACK_IMPORTED_MODULE_3__.Trigger; },
/* harmony export */   "PopoverType": function() { return /* binding */ PopoverType; }
/* harmony export */ });
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _relativePopover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./relativePopover */ "./src/relativePopover.tsx");
/* harmony import */ var _absolutePopover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./absolutePopover */ "./src/absolutePopover.tsx");
/* harmony import */ var _type__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./type */ "./src/type.ts");




var PopoverType;

(function (PopoverType) {
  PopoverType["relative"] = "relative";
  PopoverType["absolute"] = "absolute";
})(PopoverType || (PopoverType = {}));

/* harmony default export */ __webpack_exports__["default"] = (_relativePopover__WEBPACK_IMPORTED_MODULE_1__["default"]);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map